var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 35,
    viewBox: "0 0 2 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    x2: 1,
    y2: 37,
    stroke: "#707070",
    strokeDasharray: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalLine);
export default __webpack_public_path__ + "static/media/vertical-line.558592a66ae43ddef87e2de6584997c6.svg";
export { ForwardRef as ReactComponent };